(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neon-palette"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('catidea-neon-palette')) {
    customElements.define(
      'catidea-neon-palette',
      class extends HTMLElement {
        connectedCallback() {
          this.toggleInput = this.querySelector('[data-np-toggle]');
          if (this.toggleInput && !this.initialized) {
            this.initialized = true;
            this.toggleInput.addEventListener('change', () => {
              this.syncState(this.toggleInput.checked);
            });
          }
          const initialActive = this.toggleInput ? this.toggleInput.checked : this.dataset.hdrActive === 'true';
          this.syncState(initialActive);
          this.renderHdrCanvases();
        }

        syncState(isActive) {
          this.classList.toggle('is-hdr-on', isActive);
          this.dataset.hdrActive = String(isActive);
          if (this.toggleInput) {
            this.toggleInput.setAttribute('aria-checked', String(isActive));
          }
        }

        async renderHdrCanvases() {
          const lines = Array.from(this.querySelectorAll('[data-np-line]'));
          if (!lines.length) return;

          const boost = Math.max(1.2, Number(this.dataset.hdrBoost) || 2.2);
          let gpuDevice = null;

          if (navigator.gpu && typeof navigator.gpu.requestAdapter === 'function') {
            try {
              const adapter = await navigator.gpu.requestAdapter();
              if (adapter) {
                gpuDevice = await adapter.requestDevice();
              }
            } catch (_err) {
              gpuDevice = null;
            }
          }

          for (const line of lines) {
            const canvas = line.querySelector('.np-line-canvas');
            if (!(canvas instanceof HTMLCanvasElement)) continue;

            const r = Math.min(1, Math.max(0, Number(line.dataset.r) || 0));
            const g = Math.min(1, Math.max(0, Number(line.dataset.g) || 0));
            const b = Math.min(1, Math.max(0, Number(line.dataset.b) || 0));

            if (gpuDevice && this.paintWebGpuHdr(canvas, gpuDevice, r, g, b, boost)) {
              continue;
            }
            this.paintCanvas2dP3(canvas, r, g, b);
          }
        }

        paintWebGpuHdr(canvas, device, r, g, b, boost) {
          try {
            const ctx = canvas.getContext('webgpu');
            if (!ctx) return false;

            try {
              ctx.configure({
                device,
                format: 'rgba16float',
                colorSpace: 'display-p3',
                toneMapping: { mode: 'extended' },
                alphaMode: 'premultiplied',
              });
            } catch (_configErr) {
              ctx.configure({
                device,
                format: 'rgba16float',
                alphaMode: 'premultiplied',
              });
            }

            const encoder = device.createCommandEncoder();
            const pass = encoder.beginRenderPass({
              colorAttachments: [
                {
                  view: ctx.getCurrentTexture().createView(),
                  loadOp: 'clear',
                  clearValue: {
                    r: r * boost + 0.12,
                    g: g * boost + 0.12,
                    b: b * boost + 0.12,
                    a: 1.0,
                  },
                  storeOp: 'store',
                },
              ],
            });
            pass.end();
            device.queue.submit([encoder.finish()]);
            return true;
          } catch (_err) {
            return false;
          }
        }

        paintCanvas2dP3(canvas, r, g, b) {
          try {
            const ctx = canvas.getContext('2d', { colorSpace: 'display-p3' }) || canvas.getContext('2d');
            if (!ctx) return;
            ctx.fillStyle = `color(display-p3 ${r} ${g} ${b})`;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
          } catch (_err) {
            // CSS background-color fallback remains active
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-main-v3"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('catidea-product-main-v3')) {
    customElements.define(
      'catidea-product-main-v3',
      class extends HTMLElement {
        connectedCallback() {
          this.initializeModelViewer();
          if (this.galleryInitialized) return;
          this.galleryInitialized = true;
          this.addEventListener('click', (event) => {
            if (!(event.target instanceof Element)) return;
            const scrollButton = event.target.closest('.thumbnail-scroll');
            if (scrollButton && this.contains(scrollButton)) {
              const thumbnails = this.querySelector('.thumbnail-gallery .thumbs');
              if (!thumbnails) return;
              thumbnails.scrollBy({
                left: Number(scrollButton.dataset.scrollDirection) * thumbnails.clientWidth,
                behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
              });
              return;
            }
            const button = event.target.closest('.thumb');
            if (!button || !this.contains(button) || button.classList.contains('active')) return;
            const mediaTemplate = this.querySelector(`template[data-media-id="${button.dataset.mediaId}"]`);
            const activeMedia = this.querySelector('.active-media');
            if (!mediaTemplate || !activeMedia) return;
            activeMedia.querySelectorAll('video').forEach((video) => video.pause());
            this.destroyModelViewer();
            activeMedia.replaceChildren(mediaTemplate.content.cloneNode(true));
            this.initializeModelViewer();
            this.querySelectorAll('.thumb').forEach((thumbnail) => {
              const active = thumbnail === button;
              thumbnail.classList.toggle('active', active);
              thumbnail.setAttribute('aria-pressed', String(active));
            });
          });
        }

        disconnectedCallback() {
          this.destroyModelViewer();
        }

        initializeModelViewer() {
          const model = this.querySelector('.active-media model-viewer');
          if (!model || !window.Shopify?.loadFeatures || this.modelViewerRequest) return;
          const request = {};
          this.modelViewerRequest = request;
          window.Shopify.loadFeatures([{
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: (errors) => {
              if (this.modelViewerRequest !== request) return;
              if (errors || !model.isConnected || !window.Shopify.ModelViewerUI) {
                this.modelViewerRequest = null;
                return;
              }
              this.modelViewerUI = new window.Shopify.ModelViewerUI(model, { focusOnPlay: false });
              this.modelViewerUI.play();
            },
          }]);
        }

        destroyModelViewer() {
          this.modelViewerRequest = null;
          this.modelViewerUI?.destroy();
          this.modelViewerUI = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
